import { Img } from "components";
import Stepper from "../Stepper";
import AvatarVideo from "../AvatarVideo";
import { Link } from "react-router-dom";

interface Props {
  title: any;
  description?: any;
  body: any;
  videoLinks?: any[] | any;
  stepperNotRequired?: boolean;
  titleSize?: string;
  descriptionSize?: string;
  headerClasses?: string;
  outerBodyClassesBG?: string;
  innerBodyClasses?: string;
  textAboveTitle?: string;
  textAboveTitleClass?: string;
  addSubTitle?: any;
  wrapperTitleClasses?: string;
  innerBodyStyle?: object;
  disableNavigation?: string;
}

const Wrapper = ({
  disableNavigation,
  innerBodyStyle,
  wrapperTitleClasses,
  title,
  description,
  body,
  videoLinks,
  stepperNotRequired,
  titleSize,
  headerClasses,
  descriptionSize,
  outerBodyClassesBG,
  innerBodyClasses,
  textAboveTitle,
  textAboveTitleClass,
  addSubTitle,
}: Props) => {
  return (
    <div
      className={`flex justify-center min-h-screen ${
        !!outerBodyClassesBG
          ? outerBodyClassesBG
          : "bg-[url(/public/images/soomuch-demo/background2.svg)] bg-no-repeat bg-cover bg-center"
      }`}
    >
      <div
        style={innerBodyStyle || {}}
        className={`font-manrope pt-[2vh] px-[10vh] pb-[2vh] flex flex-col justify-between w-full ${
          !!innerBodyClasses ? innerBodyClasses : ""
        }`}
      >
        <div className={`flex ${headerClasses}`}>
          <div className="grid grid-cols-12 gap-4 w-full">
            <div className="col-span-2 space-y-3">
              <Link to={"/explore"}>
                <img
                  src="/images/soomuch-demo/logo.svg"
                  className="w-[40vh]"
                  // enableShimmer={false}
                />
              </Link>
              <div>
                <img
                  src="/images/soomuch-demo/Patent.svg"
                  className="w-[18vh]"
                  // enableShimmer={false}
                />
              </div>
            </div>
            <div
              className={`text-center self-end space-y-[0.8vh] col-span-8 ${
                !!wrapperTitleClasses ? wrapperTitleClasses : ""
              }`}
            >
              {!!textAboveTitle && (
                <p
                  className={`${
                    !!textAboveTitleClass
                      ? textAboveTitleClass
                      : "text-[2vh] font-manropeSB text-[black]"
                  }`}
                >
                  {textAboveTitle}
                </p>
              )}
              <h1
                className={`font-inter text-[black] ${
                  !!titleSize ? titleSize : "text-[6vh]"
                } font-bold leading-[120%]`}
              >
                {title}
              </h1>
              {!!addSubTitle && addSubTitle}
              {!!description && (
                <p
                  className={`${
                    !!descriptionSize ? descriptionSize : "text-[2vh]"
                  } font-medium text-[#54504D]`}
                >
                  {description}
                </p>
              )}
            </div>
            <div className="col-span-2 flex justify-end">
              {!!videoLinks?.length && Array.isArray(videoLinks) ? (
                <AvatarVideo videoLinks={videoLinks} />
              ) : !!videoLinks ? (
                videoLinks
              ) : (
                <Img
                  src={"/images/soomuch-demo/VideoLoader.png"}
                  className="w-[18vh] h-[18vh] object-top object-cover rounded-lg shadow-2xl shadow-[gray]"
                  enableShimmer={false}
                />
              )}
            </div>
          </div>
        </div>
        {body}
        {!stepperNotRequired && (
          <Stepper disableNavigation={disableNavigation} />
        )}
      </div>
    </div>
  );
};

export default Wrapper;
